<template>
	<div>
		<titles titlename="1X任务考核管理" titlecontent="1X任务考核管理" :mbx="paths"></titles>
		<div class="assessmenttasktitle">
			<el-button @click="lookxqkh" type="primary" icon="el-icon-plus">添加新任务</el-button>
			<div class="assessmenttasksreach">
				<el-input placeholder="请选择新任务" v-model="searchinput"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
			</div>
		</div>
		<div class="assessmenttaskcontent">
			<div class="assessmenttaskitem" v-for="item in list" :key="item.JX_GUID">
				<div class="assessmenttaskitemimgbox"><img class="assessmenttaskitemimg" src="@/assets/assessmenttaskdefault.svg" alt="" /></div>
				<p class="assessmenttaskitemtitle">{{ item.ExamName }}</p>
				<div class="usercontent">
					<img src="@/assets/userion.svg" alt="" />
					<p>
						报名人数 -
						<span style="color: #FF6B00;">{{ item.Enrollment ?? 0 }}</span>
					</p>
				</div>
				<div class="usercontent">
					<img src="@/assets/dateicon.svg" alt="" />
					<div class="usercontentitle">
						<p>报名截止时间:</p>
						<p>{{ item.Deadlinedate ?? '' }}</p>
					</div>
				</div>
				<div class="usercontent">
					<img src="@/assets/dateicon.svg" alt="" />
					<div class="usercontentitle">
						<p>考试时间:</p>
						<p>{{ item.Examdate ?? '' }}</p>
					</div>
				</div>
				<div class="usercontent">
					<!-- <img src="@/assets/dateicon.svg" alt="" /> -->
					<div class="usercontentitle">
						<p>试卷名称:</p>
						<p>{{ item.SPA_PaperCode }}</p>
					</div>
				</div>
				<p class="assessmenttaskitembtntext" @click="goxqurl(item)">
					更多详情
					<span class="el-icon-right"></span>
				</p>
			</div>
		</div>

		<div class="paginationbox" v-if="allnums > list.length">
			<el-pagination
				background
				layout="prev, pager, next"
				@current-change="handleCurrentChange"
				:current-page="pageIndex"
				:page-size="pageSize"
				:total="allnums"
			></el-pagination>
		</div>
		<div style="width: 100%;background-color: #fff;" v-if="list.length == 0"><el-empty description="暂无1x考核任务"></el-empty></div>

		<el-dialog title="请添加考核任务" :visible.sync="dialogVisible" :before-close="handleClose">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
				<el-form-item label="专业" prop="pro_guid">
					<el-select v-model="ruleForm.pro_guid" placeholder="请选择专业" @change="getpolist()">
						<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="岗位" prop="PR_GUID">
					<el-select v-model="ruleForm.PR_GUID" placeholder="请选择岗位">
						<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="等级" prop="IL_GUID">
					<el-select v-model="ruleForm.IL_GUID" clearable placeholder="请选择等级">
						<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="任务名称" prop="ExamName"><el-input v-model="ruleForm.ExamName" placeholder="请输入试卷名称"></el-input></el-form-item>
				<el-form-item label="截止报名时间" prop="Deadlinedate">
					<el-date-picker v-model="ruleForm.Deadlinedate" type="datetime" placeholder="选择日期时间"></el-date-picker>
				</el-form-item>

				<el-form-item label="组卷" prop="SPA_PaperCode">
					<div class="datetimechiocebox">
						<p style="color: red;">（注：选择手动组卷需要在试卷管理界面添加试卷）</p>
						<div style="display: flex;">
							<el-button @click="changesrule" type="primary" size="mini" icon="el-icon-circle-plus-outline">选择试卷</el-button>
							<p style="margin-left: 10px;" v-if="!ischioceitem">请选择试卷</p>
							<p style="margin-left: 10px;color: #009933;" v-if="ischioceitem">{{ ischioceitem.SPA_PaperTitle }}</p>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="考试开始时间" prop="Examdate">
					<el-date-picker v-model="ruleForm.Examdate" type="datetime" placeholder="选择日期时间"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitFormdr('ruleForm')">立即增加</el-button>
					<el-button @click="resetForm('ruleForm')">重置</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-drawer :visible.sync="drawer" title="添加试卷">
			<examinationmanage v-if="drawer" :ischioceitem="ischioceitem" :ruleFormchildren="ruleForm"></examinationmanage>
		</el-drawer>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { getGetProfList, getPositionList, changeGradeGet, AddJxPaper, GetJxPaperList } from '@/request/api/homesview/yunhomes/yunhom.js';
import { GetzyProfList } from '@/request/api/mange/mange.js';
import examinationmanage from './components/examinationmanage.vue';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 标题组件
			paths: [
				{
					path: '/assessmenttask/Assessmenttaskmange',
					name: '1X任务考核管理'
				}
			],
			drawer: false,
			searchinput: '',
			dialogVisible: false,
			ruleForm: {
				PR_GUID: '',
				pro_guid: '',
				IL_GUID: '',
				SPA_PaperCode: '',
				SPA_GUID: '',
				ExamName: '',
				Deadlinedate: '',
				Examdate: ''
			},
			rules: {
				pro_guid: [{ required: true, message: '请选择专业', trigger: 'blur' }],
				PR_GUID: [{ required: true, message: '请选择岗位', trigger: 'blur' }],
				IL_GUID: [{ required: true, message: '请选择等级', trigger: 'blur' }],
				SPA_PaperCode: [{ required: true, message: '请选择试卷', trigger: 'blur' }],
				ExamName: [{ required: true, message: '请选择任务名称', trigger: 'blur' }],
				Deadlinedate: [{ required: true, message: '请选择截止报名时间', trigger: 'blur' }],
				Examdate: [{ required: true, message: '请选择考试开始时间', trigger: 'blur' }]
			},
			prolist: [],
			polist: [],
			gradeget: [],
			ischioceitem: null,
			list: [],
			pageIndex: 1,
			pageSize: 10,
			allnums: 0
		};
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.init();
		// console.log('任务考核列表');
		this.getprolist();
		this.getgrads();
	},
	provide() {
		return {
			fatherMethod: this.fatherMethodHandle
		};
	},
	components: {
		titles,
		examinationmanage
	},
	methods: {
		init() {
			let datas = {
				where: '',
				pageIndex: this.pageIndex,
				pageSize: this.pageSize
			};
			GetJxPaperList(datas).then(res => {
				// console.log(res,'获取list')
				this.list = res.data.data.list;
				this.allnums = res.data.data.totalCount;
			});
		},
		goxqurl(ite) {
			this.$router.push('/assessmenttask/Assessmenttaskxq?id=' + ite.JX_GUID);
		},
		handleCurrentChange(val) {
			// console.log(val, '分页1111');
			this.pageIndex = val;
			this.init();
		},
		fatherMethodHandle(row) {
			// console.log('获取子组件',row);
			this.ischioceitem = row;

			this.ruleForm.SPA_PaperCode = row.SPA_PaperTitle;

			this.drawer = false;
		},
		changesrule() {
			this.drawer = true;
			// console.log('获取父组件',this.ruleForm);
		},

		submitFormdr(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.ruleForm.SPA_GUID = this.ischioceitem.SPA_GUID;
					let AddJxobjs = JSON.parse(JSON.stringify(this.ruleForm));
					AddJxobjs.Examdate = this.changestimer(this.ruleForm.Examdate);
					AddJxobjs.Deadlinedate = this.changestimer(this.ruleForm.Deadlinedate);
					AddJxPaper(AddJxobjs).then(res => {
						// console.log('添加1+任务',res)
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.ruleForm = {
								PR_GUID: '',
								pro_guid: '',
								IL_GUID: '',
								SPA_PaperCode: '',
								SPA_GUID: '',
								ExamName: '',
								Deadlinedate: '',
								Examdate: ''
							};
							this.dialogVisible = false;
							this.init();
						} else {
							// this.$message(res.data.msg);
						}
					});
				} else {
					return false;
				}
			});
		},

		changestimer(timer) {
			let date = new Date(timer);
			let year = date.getFullYear();
			let month = ('0' + (date.getMonth() + 1)).slice(-2); // 添加前导零
			let day = ('0' + date.getDate()).slice(-2); // 添加前导零
			let hours = ('0' + date.getHours()).slice(-2); // 添加前导零
			let minutes = ('0' + date.getMinutes()).slice(-2); // 添加前导零
			let seconds = ('0' + date.getSeconds()).slice(-2); // 添加前导零

			let formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
			return formattedDate;
			// console.log(formattedDate); // 输出格式为 "yyyy-MM-dd HH:mm:ss" 的日期时间
		},

		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		lookxqkh() {
			// console.log('显示');
			this.dialogVisible = true;
		},
		getprolist() {
			this.prolist = [];
			if (localStorage.getItem('uiguid') == 'f2b9986b57074d2cb2dadd07f6ee62bb') {
				getGetProfList().then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						this.getpolist();
					}
				});
			} else {
				GetzyProfList(localStorage.getItem('siguid')).then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						this.getpolist();
					}
				});
			}
		},
		getpolist() {
			let proguid = '';
			if (this.ruleForm.pro_guid != '') {
				proguid = this.ruleForm.pro_guid;
			}
			this.ruleForm.PR_GUID = '';
			this.polist = [];
			if (proguid == '') {
				return;
			}

			getPositionList(proguid).then(res => {
				// console.log(res, '岗位');
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},
		getgrads() {
			changeGradeGet().then(res => {
				// console.log("获取等级",res)
				this.gradeget = res.data.data;
			});
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(() => {
					done();
				})
				.catch(() => {});
		}
	}
};
</script>

<style scoped lang="less">
.paginationbox {
	width: 100%;
	background-color: #fff;
	padding: 20px 0;
	border-radius: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 20px 0;
	box-sizing: 0 0 16px 0 rgba(0, 0, 0, 0.12);
}

:deep .el-drawer__header {
	font-size: 20px;
	font-weight: 500;
	color: #000 !important;
}

.addstrascenter {
	.ridioslist {
		border: 1px solid #ccc;
		margin: 10px 0;
		position: relative;

		.qustridios {
			background-color: #f2f2f2;
			font-size: 16px;
			padding-left: 10px;
		}
	}

	.qustiopn {
		display: flex;
		align-items: center;
		letter-spacing: 1px;
		margin: 10px;

		p {
			margin: 0 5px;
		}

		.chioce:nth-of-type(2) {
			text-decoration: underline;
			color: rgb(0, 0, 255);
			cursor: pointer;
		}

		div {
			margin-right: 5px;
		}
	}
}

.assessmenttaskcontent {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-top: 40px;
	gap: 2%;

	.assessmenttaskitem {
		width: 18%;
		// column-gap: 10px;
		margin-bottom: 20px;
		overflow: hidden;
		background-color: #fff;
		border-radius: 10px;
		box-sizing: border-box;
		box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.4);

		.assessmenttaskitembtntext {
			padding: 10px 0;
			font-size: 16px;
			text-align: center;
			cursor: pointer;
			position: relative;
			&::after {
				content: '';
				position: absolute;
				width: 0%;
				height: 2px;
				bottom: 0;
				left: 0;
				background-color: #bdbdbd;
				transition: all 1s;
			}
		}

		.assessmenttaskitembtntext:hover {
			&::after {
				width: 100%;
			}
		}

		.assessmenttaskitemimg {
			width: 100%;
			height: 200px;
			transition: all 1s;
		}

		.assessmenttaskitemimgbox {
			width: 100%;
			height: 200px;
			overflow: hidden;
			border-radius: 10px;
			box-sizing: border-box;
		}

		.assessmenttaskitemimg:hover {
			transform: scale(1.2);
		}

		.usercontent {
			padding: 10px 20px;
			display: flex;
			align-items: center;
			img {
				margin-right: 10px;
			}
			.usercontentitle {
				font-size: 14px;
			}
			p {
				font-size: 14px;
			}
		}

		.assessmenttaskitemtitle {
			font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
			font-weight: 700;
			font-style: normal;
			font-size: 18px;
			margin: 20px 0 0 20px;
		}
	}
}

.assessmenttasktitle {
	height: 60px;
	display: flex;
	align-items: center;
	width: 100%;
	border-radius: 5px;
	// border: 1px solid;
	box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.4);
	background-color: #fff;
	justify-content: space-between;
	padding: 0 10px;
}
</style>
